import React from 'react';
import useMedia from 'use-media';
import { Image } from '../atoms/image';

export const SubHeader = (props) => {
    const isWideTablet = useMedia({ maxWidth: '960px' });
    return (
        <div style={isWideTablet ? styles.subHeaderArea2 : styles.subHeaderArea}>
            <Image
                image={props.SubImage}
                style={isWideTablet ? styles.subHeadImg : styles.subHeadImg2}
            />
        </div>
    );
}
const styles = {
    subHeaderArea: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "5rem",
        background: "#f5f5f5",
    },
    subHeaderArea2: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        padding: "1rem 0px",
        margin: "0px auto",
        background: "#f5f5f5",
    },
    subHeadImg: {
        height: "auto",
        width: "50%"
    },
    subHeadImg2: {
        width: "auto",
        height: "4rem",
        padding: "0.5rem",
    }
}